import { render, staticRenderFns } from "./Demographics.vue?vue&type=template&id=78112260"
import script from "./Demographics.vue?vue&type=script&lang=ts"
export * from "./Demographics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/livingDonors/_locales/Demographics.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FlivingDonors%2FDemographics.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports